export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új Rapid Antigén teszt',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "commercialName",
                label: "Teszt neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "manufacturerId",
                label: "Gyártó azonosító",
                visibility: false,
                formType: 'number',
                formSize: 3,
                formVisible: true
            },
            {
                name: "manufacturerName",
                label: "Gyártó neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "idDevice",
                label: "Teszt azonosító",
                visibility: false,
                formType: 'number',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "ogyei",
                label: "OGYEI",
                visibility: false,
                formType: 'checkbox',
                formSize: 3,
                formVisible: true
            },
            {
                name: "ceMarking",
                label: "CE marking",
                visibility: false,
                formType: 'checkbox',
                formSize: 3,
                formVisible: true
            },
            {
                name: "hscCommonList",
                label: "DCC kiállítható",
                visibility: true,
                formType: 'checkbox',
                slot_name: "checkFormat1",
                formSize: 3,
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
